import { Switch } from "@shared/components/DataEntry";

import { useActiveDiscountSwitch } from "./controller";
import { ActiveDiscountSwitchProps } from "./types";

export function ActiveDiscountSwitch(props: ActiveDiscountSwitchProps) {
  const { isActive, isPending, toggle } = useActiveDiscountSwitch(props);

  return (
    <Switch
      checked={isActive}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
